export default {
  total: "Total",
  paid: "Paid",
  unpaid: "Unpaid",
  editor: "Editor",
  viewer: "Guest",
  view: 'View',
  save: 'Save',
  cancel: 'Cancel',
  delete: 'Delete',
  edit: 'Edit',
  add: 'Add',
  close: 'Close',
  confirm: 'Confirm',
  yes: 'Yes',
  no: 'No',
  loading: 'Loading...',
  error: 'Error',
  success: 'Success',
  warning: 'Warning',
  info: 'Information',
  search: 'Search',
  filter: 'Filter',
  sort: 'Sort',
  export: 'Export',
  import: 'Import',
  download: 'Download',
  upload: 'Upload',
  print: 'Print',
  share: 'Share',
  copy: 'Copy',
  paste: 'Paste',
  cut: 'Cut',
  undo: 'Undo',
  redo: 'Redo',
  refresh: 'Refresh',
  back: 'Back',
  next: 'Next',
  previous: 'Previous',
  first: 'First',
  last: 'Last',
  all: 'All',
  none: 'None',
  select: 'Select',
  deselect: 'Deselect',
  clear: 'Clear',
  reset: 'Reset',
  apply: 'Apply',
  submit: 'Submit',
  send: 'Send',
  receive: 'Receive',
  create: 'Create',
  update: 'Update',
  remove: 'Remove',
  duplicate: 'Duplicate',
  move: 'Move',
  upgrade: 'Upgrade',
  details: 'Details',
  more: "More",
  less: "Less",
  show: "Show",
  hide: "Hide",
  actions: {
    _self: "Actions",
    add: "Add",
    addLong: "Add new item",
    importGuests: "Import guests",
    share: "Share",
    useExample: "Use example",
    addEvent: "Add event",
    addExamples: "Add examples",
    addingExamples: "Adding examples...",
    edit: "Edit",
    delete: "Delete",
    cancel: "Cancel",
    save: "Save"
  },
  noResults: 'No results found',
  pagination: {
    showing: 'Showing {{from}} to {{to}} of {{total}} items'
  },
  time: "Time",
  title: "Title",
  category: "Category",
  description: "Description",
  continue: "Continue",
  required: "Required",
  optional: "Optional",
  or: "or",
  and: "and",
  selectAll: "Select all",
  deselectAll: "Deselect all",
  content: "Content",
  today: "Today",
  yesterday: "Yesterday",
  saving: "Saving...",
  viewAll: "View all",
  currentEvent: "Current Event",
  pwa: {
    offlineReady: 'App ready to work offline',
    newContent: 'New content available, click on reload button to update.',
    reload: 'Reload'
  },

  // New additions
  disconnect: "Disconnect",
  sending: "Sending...",
  verified: "Verified",
  importGuests: "Import guests",

  status: {
    to_contact: "To Contact",
    contacted: "Contacted",
    meeting_scheduled: "Meeting Scheduled",
    quote_received: "Quote Received",
    hired: "Hired",
    deposit_paid: "Deposit Paid",
    completed: "Completed",
    cancelled: "Cancelled",
    pending: "Pending",
    confirmed: "Confirmed",
    declined: "Declined",
    accepted: "Accepted",
    inProgress: "In Progress",
    paid: "Paid",
    unpaid: "Unpaid",
    overdue: "Overdue",
    scheduled: "Scheduled",
    done: "Done",
    todo: "To do",
    researching: "Researching"
  },

  categories: {
    other: "Other",
    venue: "Venue",
    catering: "Catering",
    photography: "Photography",
    music: "Music",
    decoration: "Decoration",
    flowers: "Flowers",
    attire: "Attire",
    jewelry: "Jewelry",
    transport: "Transport",
    lodging: "Lodging",
    ceremony: "Ceremony",
    reception: "Reception",
    videography: "Videography",
    florist: "Florist",
    cake: "Cake",
    dress: "Dress",
    suit: "Suit",
    hair_makeup: "Hair & Makeup",
    beauty: "Beauty"
  },

  validation: {
    required: {
      firstName: "First name is required",
      lastName: "Last name is required",
      email: "Email is required"
    },
    invalid: {
      email: "Email is invalid"
    }
  },

  empty: {
    title: "No data",
    description: "Nothing to display for now."
  },

  errors: {
    submit: "Error submitting",
    loadGuests: "Error loading guests",
    updateGuest: "Error updating guest",
    socialLoginFailed: "Social login failed",
    userOrWeddingNotFound: "User or wedding not found",
    googleSignIn: "Google sign-in error",
    loadVendors: "Error loading vendors",
    addVendor: "Error adding vendor",
    updateVendor: "Error updating vendor",
    deleteVendor: "Error deleting vendor",
    saveSeatingPlan: "Error saving seating plan",
    generateSeatingPlan: "Error generating seating plan"
  },

  columns: {
    name: "Name",
    status: "Status",
    category: "Category",
    actions: "Actions",
    plusOne: "+1",
    children: "Children"
  },

  confirmDialog: {
    delete: "Are you sure you want to delete this item?",
    budgetRemoval: {
      title: "Delete budget",
      message: "Do you really want to delete this budget?",
      confirm: "Delete",
      cancel: "Cancel"
    }
  },

  deleteConfirmation: {
    title: "Delete",
    description: "This action is irreversible.",
    confirmTitle: "Confirm deletion",
    confirmDescription: "Are you sure you want to delete this item?",
    confirmButton: "Delete"
  },

  sortOptions: {
    title: "Sort by"
  },

  sharing: {
    title: "Sharing",
    share: "Share",
    accessLevel: "Access Level",
    accessCode: "Access Code",
    readOnly: "Read Only",
    edit: "Edit",
    copy: "Copy Link",
    copied: "Link copied!",
    emailPlaceholder: "example@email.com",
    namePlaceholder: "Recipient Name",
    messagePlaceholder: "Add a personal message...",
    recipientEmail: "Recipient Email",
    recipientName: "Recipient Name",
    message: "Message",
    defaultMessage: "I invite you to collaborate on my wedding!",
    invitationCreated: "Invitation created successfully",
    success: "Shared successfully"
  }
};
